import { Link } from "react-router-dom";
import { ArrowUpRight, Home, Wrench, Wind, Paintbrush, Hammer, Construction, Zap, Triangle } from "lucide-react";
import { SERVICES } from "@/lib/site";

const ICONS = {
  home: Home,
  wrench: Wrench,
  wind: Wind,
  paintbrush: Paintbrush,
  hammer: Hammer,
  construction: Construction,
  zap: Zap,
  roof: Triangle,
};

export default function ServicesBento() {
  return (
    <section data-testid="services-bento" className="section-pad">
      <div className="container-page">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-12">
          <div>
            <p className="overline mb-3">What we do</p>
            <h2 className="heading-2 max-w-2xl">Full-service construction, under one roof.</h2>
          </div>
          <Link to="/services" data-testid="services-view-all" className="btn-ghost shrink-0">
            All services <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-6 gap-4 md:gap-5">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon] || Home;
            const isFeature = i === 0;
            // 8 cards: 1 big feature (4×2) + 2 stacked right (2×1 each)
            // + remaining 5: row of 3 col-span-2, then row of 2 col-span-3
            let span;
            if (isFeature) span = "md:col-span-4 md:row-span-2";
            else if (i >= SERVICES.length - 2) span = "md:col-span-3";
            else span = "md:col-span-2";

            return (
              <Link
                key={s.slug}
                to={`/services/${s.slug}`}
                data-testid={`service-card-${s.slug}`}
                className={`group relative overflow-hidden rounded-md border border-brand-line bg-white ${span}`}
              >
                <div className={`relative ${isFeature ? "aspect-[5/4]" : "aspect-[4/3]"} overflow-hidden`}>
                  <img
                    src={s.image}
                    alt={s.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-brand-obsidian/85 via-brand-obsidian/15 to-transparent" />
                  <div className="absolute top-4 left-4">
                    <div className="w-9 h-9 rounded-sm bg-white/90 flex items-center justify-center">
                      <Icon className="w-4 h-4 text-brand-obsidian" strokeWidth={1.75} />
                    </div>
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6 text-white">
                    <h3 className={`font-heading font-bold tracking-tight ${isFeature ? "text-2xl md:text-3xl" : "text-xl"}`}>
                      {s.title}
                    </h3>
                    <p className="text-sm text-white/85 mt-1.5 max-w-md">{s.short}</p>
                    <span className="inline-flex items-center gap-1 mt-3 text-xs font-semibold uppercase tracking-[0.2em] text-white/90 group-hover:text-white">
                      Learn more <ArrowUpRight className="w-3.5 h-3.5" />
                    </span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
